import { taskList } from "@/common/api/task.js";
import { debounce } from "@/common/utils";

const upDateTask = debounce(async ({ commit, dispatch }) => {
  let data = await taskList();
  if (data.status == 200) {
    commit("upDateDailyList", data.data.day_list);
    commit("upDateGradeList", data.data.grow_list);
    // data.data.day_status = Math.round(Math.random());
    // console.log(data.data.day_status);
    if (data.data.day_status == 1 || data.data.grow_status == 1) {
      dispatch(
        "upDateDot",
        {
          target: {
            class: ".navigate .icon-task",
            top: -0.12,
            right: 0,
          },
        },
        {
          root: true,
        }
      );
    } else {
      dispatch(
        "upDateDot",
        {
          target: {
            class: ".navigate .icon-task",
          },
          increase: false,
        },
        {
          root: true,
        }
      );
    }
    if (data.data.day_status == 1) {
      dispatch(
        "upDateDot",
        {
          target: {
            class: "#taskList .daily",
            top: 0.12,
            right: 0.4,
          },
        },
        {
          root: true,
        }
      );
    } else {
      dispatch(
        "upDateDot",
        {
          target: {
            class: "#taskList .daily",
          },
          increase: false,
        },
        {
          root: true,
        }
      );
    }
    if (data.data.grow_status == 1) {
      dispatch(
        "upDateDot",
        {
          target: {
            class: "#taskList .grow",
            top: 0.12,
            right: 0.4,
          },
        },
        {
          root: true,
        }
      );
    } else {
      dispatch(
        "upDateDot",
        {
          target: {
            class: "#taskList .grow",
          },
          increase: false,
        },
        {
          root: true,
        }
      );
    }
  }
}, 100);

export default {
  namespaced: true,
  state: {
    gradeTaskList: [],
    dailyTaskList: [],
  },
  mutations: {
    // 成长任务列表
    upDateGradeList(state, list) {
      state.gradeTaskList = list || [];
    },
    // 每日任务列表
    upDateDailyList(state, list) {
      state.dailyTaskList = list;
    },
  },
  actions: {
    upDateTaskList: upDateTask,
  },
};
